import { Component, OnInit } from '@angular/core';
import { RankingService } from '../ranking.service';
import { RankingApi } from '../ranking.api';
import { SharedModule } from '@app/shared/shared.module';
import { RankingRowComponent } from '../ranking-row/ranking-row.component';
import { iRankingRow } from '../ranking.interface';

@Component({
  selector: 'app-ranking-list',
  standalone: true,
  imports: [
		SharedModule,
		RankingRowComponent,
	],
	providers: [
		RankingService,
		RankingApi,
	],
  templateUrl: './ranking-list.component.html',
  styleUrl: './ranking-list.component.scss'
})
export class RankingListComponent implements OnInit {
	public loading: boolean = false;
	public ranking: iRankingRow[] = [];

	constructor(
		private service: RankingService,
	) {
	}

	ngOnInit(): void {
		this.loadRanking();
	}

	public loadRanking() {
		this.loading = true;
		this.service.getFullRanking()
			.subscribe({
				next: (rs) => {
					console.log("ranking ", rs);
					this.ranking = rs;
					this.loading = false;
				},
				error: (err) => {
					console.error ("error: ", err);
					this.loading = false;
				}
			});
	}

}
